import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';
import queryString from 'query-string';
import axios from '../utils/axios';
import Datos from './datasets/Datos';
import Warning from './Warning';
import { useTranslation } from 'react-i18next';

const styles = theme => ({
  container: {
    padding: 0
  },
  paper: {
    width: 'auto',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0
    }
  },
  filtros: {
    color: '#e54b4b'
  }
});

const Actividades = ({ t, ...props }) => {
  const { classes, enqueueSnackbar } = props;
  const { i18n } = useTranslation();
  // const [baseObject, setBaseObject] = useState({ ...mainDefault });
  const { tipoDeServicioId, departamentoId, ciudadId } = queryString.parse(
    props.location.search
  );

  const [tipoDeServicio, setTipoDeServicio] = useState();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const buildGetCallback = (errorMessage, callback) => {
    if (callback) {
      callback([]);
    }
    enqueueSnackbar(errorMessage, {
      variant: 'error'
    });
  };

  useEffect(
    () => {
      axios
        .get(`inversionistastiposervicio/${tipoDeServicioId}`)
        .then(r => {
          if (i18n.language === 'es') {
            setTipoDeServicio(r.data.descripcion);
          }
          if (i18n.language === 'en') {
            setTipoDeServicio(r.data.descIngles);
          }
          if (i18n.language === 'pt') {
            setTipoDeServicio(r.data.descPortugues);
          }
        })
        .catch(() => {
          buildGetCallback('Error al obtener el tipo de servicio');
        });
    },
    [tipoDeServicioId, buildGetCallback]
  );

  return (
    <div>
      <Container maxWidth="xl" className={classes.container}>
        <Warning />
        <Paper className={classes.paper} elevation={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <h3>
                Tipo de servicio:{' '}
                <span className={classes.filtros}>{tipoDeServicio}</span>
              </h3>
            </Grid>
          </Grid>
        </Paper>
      </Container>
      <Datos
        {...props}
        {...{ departamentoId, tipoDeServicioId, ciudadId }}
        classes={undefined}
      />
    </div>
  );
};

Actividades.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withSnackbar(withStyles(styles)(Actividades));
